import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    disable: true,
    dark: false,
    themes: {
      light: {
        primary: '#FFF347',
        secondary: '#9D9C9C',
        accent: '#90BE6D',
        error: '#EF626C',
        sienna: '#EA8F56',
      },
    },
  },
  rtl: false,
  breakpoint: {
    thresholds: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
    scrollBarWidth: 24,
  },
});
